import { makeStyles } from "@material-ui/core";

const useCellStyles = makeStyles((theme) => ({
  tableCell: {
    flex: 1,
    padding: theme.spacing(1, 4),
    display: "table-cell",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",

    "&.error": {
      border: `2px dashed ${theme.palette.error.main}`,
    },

    "&.isNegative": {
      border: `2px dashed ${theme.palette.error.main}`,
      color: theme.palette.error.main,
    },

    "&.MuiVirtualizedTable-column-billingPercentual.isNegative": {
      borderLeft: "none",
      borderRight: "none",
    },

    "&:has(.MuiVirtualizedTable-cell-input)": {
      textOverflow: "unset",
    },
  },
  tableHeadCell: {
    flex: 1,
    display: "table-cell",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  tableHeadCellWithGroup: {
    padding: "0.5rem 0 0.3rem 0 !important",
  },
  hasClick: {
    cursor: "pointer",
  },
}));

export default useCellStyles;
